import React, { useEffect, useState } from "react";

const ClockCard = () => {
  const [time, setTime] = useState(new Date());

  // Update every second
  useEffect(() => {
    const timer = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  // Extract time units
  const seconds = time.getSeconds();
  const minutes = time.getMinutes();
  const hours = time.getHours();

  // Calculate angles
  const secondDeg = seconds * 6; // 360 / 60
  const minuteDeg = minutes * 6 + seconds * 0.1; // smooth move
  const hourDeg = (hours % 12) * 30 + minutes * 0.5; // smooth move

  return (
    <div className="w-full max-w-[224px] h-44 bg-white rounded-2xl shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)] flex items-center justify-center">
      <div className="w-32 h-32 relative">
        {/* Outer circle */}
        <div className="w-32 h-32 absolute bg-zinc-100 rounded-full shadow-[0px_4px_15px_0px_rgba(0,0,0,0.25)]" />

        {/* Middle circle */}
        <div className="w-28 h-28 absolute top-[9.64px] left-[9.64px] bg-zinc-100 rounded-full shadow-[inset_1px_4px_14px_-7px_rgba(0,0,0,0.25)]" />

        {/* Center circle */}
        <div className="w-14 h-14 absolute top-[38.57px] left-[38.57px] bg-neutral-100 rounded-full shadow-[0px_4px_11px_-6px_rgba(0,0,0,0.25)]" />

        {/* Hour hand */}
        <div
          className="w-1 h-10 bg-black absolute top-8 left-[62px] origin-bottom rounded"
          style={{ transform: `rotate(${hourDeg}deg)` }}
        />

        {/* Minute hand */}
        <div
          className="w-1 h-12 bg-gray-700 absolute top-4 left-[62px] origin-bottom rounded"
          style={{ transform: `rotate(${minuteDeg}deg)` }}
        />

        {/* Second hand */}
        <div
          className="w-0.5 h-14 bg-red-500 absolute top-2 left-[63px] origin-bottom"
          style={{ transform: `rotate(${secondDeg}deg)` }}
        />

        {/* Center dot */}
        <div className="w-3 h-3 bg-black rounded-full absolute top-[60px] left-[60px]" />
      </div>
    </div>
  );
};

export default ClockCard;
